import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

type Props = {
  setShowDialog: (data: boolean) => void;
};

export function Teaser({ setShowDialog }: Props) {
  return (
    <div className="flex justify-center">
      <Card className="bg-muted lg:max-w-1/2 text-center">
        <CardHeader>
          <CardTitle className="tracking-tight">
            Ta kontroll över din digitala exponering
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-8">
          <p className="text-muted-foreground text-sm">
            Echorai hjälper dig att identifiera och minska spridningen av dina
            personuppgifter, på ett lagligt, verifierat och tryggt sätt.
          </p>
          <Button
            variant="cta"
            size="cta"
            onClick={() => setShowDialog(true)}
          >
            Bli först att testa Echorai
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
